import type { Invite as GQLInvite } from '../../../API';

export { InviteStatus, InviteType, ChatUnitType } from '../../../models';
export type Invite = Omit<GQLInvite, 'inviteeInfo'> & {
  inviteeInfo: Record<string, any>[];
  inviterInfo: Record<string, any>;
  targetInfo: Record<string, any>;
};
